module.exports = __webpack_public_path__ + "a913483e65ad77eb8b66c537fea910de.png";